import { toast } from "react-toastify";
import { getVideo, updateVideoLikeAPI, updateVideoUnlikeAPI } from "./videoAPI";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
  video: {},
  isLoading: false,
  isError: false,
  error: "",
};

// async thunk
export const fetchVideo = createAsyncThunk("video/fetchVideo", async (id) => {
  const video = await getVideo(id);
  return video;
});

export const updateVideoLike = createAsyncThunk(
  "video/updateVideoLike",
  async ({ id, likes }) => {
    const video = await updateVideoLikeAPI({ id, likes });
    return video;
  }
);

export const updateVideoUnlike = createAsyncThunk(
  "video/updateVideoUnlike",
  async ({ id, unlikes }) => {
    const video = await updateVideoUnlikeAPI({ id, unlikes });
    return video;
  }
);

const videoSlice = createSlice({
  name: "video",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchVideo.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchVideo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.video = action.payload;
      })
      .addCase(fetchVideo.rejected, (state, action) => {
        state.isLoading = false;
        state.video = {};
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(updateVideoLike.fulfilled, (state, action) => {
        state.video.likes = action?.payload?.likes;
      })
      .addCase(updateVideoLike.rejected, () => {
        toast.error("Something is wrong, Please click the like button again");
      })
      .addCase(updateVideoUnlike.fulfilled, (state, action) => {
        state.video.unlikes = action?.payload?.unlikes;
      })
      .addCase(updateVideoUnlike.rejected, () => {
        toast.error("Something is wrong, Please click the unlike button again");
      });
  },
});

export default videoSlice.reducer;
